import parkingService from '@/api/parking'
import { PARKING } from '../types'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  state: {
    parkings: [],
    sites: [],
    parkingSiteId: null,
    parkingsGroupedBySite: [],
    parkingsBySite: [],
    devicesIds: [],
    spotsCount: 0
  },
  getters: {
    siteAllParkings: (state) => {
      return state.parkingsGroupedBySite.length > 0 && state.parkingSiteId ? state.parkingsGroupedBySite.find(site => site.id == state.parkingSiteId).parkings : []
    },
    parkingSiteId: (state) => {
      return state.parkingSiteId
    },
  },
  mutations: {
    [PARKING.SET_PARKINGS] (state, parkings) {
      state.parkings = parkings
    },
    [PARKING.AVAILABLE_PARKINGS_SET](state, parkingsName) {
      state.parkingsName = parkingsName
    },
    [PARKING.SET_SITE](state, sites) {
      state.sites = sites
    },
    [PARKING.SET_ALL_PARKINGS_GROUPED_BY_SITE](state, parkingsGroupedBySite) {
      state.parkingsGroupedBySite = parkingsGroupedBySite
    },
    [PARKING.SET_PARKINGS_BY_SITE](state, parkingsBySite) {
      state.parkingsBySite = parkingsBySite
    },
    [PARKING.SET_SITE_ID](state, parkingSiteId) {
      state.parkingSiteId = parkingSiteId
    },
    [PARKING.SET_PARKING_DEVICES](state, devicesIds) {
      state.devicesIds = devicesIds
    },
    [PARKING.SET_SPOTS_COUNT](state, spotsCount) {
      state.spotsCount = spotsCount
    }
  },
  actions: {
    setParkingSiteId ({commit}, parkingSiteId) {
      commit(PARKING.SET_SITE_ID, parkingSiteId)
    },
    setParkingDevices ({commit}, devicesIds) {
      commit(PARKING.SET_PARKING_DEVICES, devicesIds)
    },
    async getParkingsList ({commit, dispatch}) {
      try {
        let response = await parkingService.getParkings()
        const {parkings, spotsCount} = response.data
        commit(PARKING.SET_PARKINGS, parkings)
        commit(PARKING.SET_SPOTS_COUNT, spotsCount)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        commit(PARKING.SET_PARKINGS, [])
        return Promise.reject(error)
      }
    },
    async getAvailableParkings({ commit, dispatch }) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        let response = await parkingService.getAvailableParkings()
        commit(PARKING.AVAILABLE_PARKINGS_SET, response.data)
      }
      finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async addParking ({dispatch}, parking) {
      try {
        await parkingService.addParking(parking)
        await dispatch('getParkingsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editParking ({dispatch}, parking) {
      try {
        await parkingService.editParking(parking)
        await dispatch('getParkingsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async getSitesWithParkings ({commit, dispatch}) {
      try {
        let response = await parkingService.getSitesWithParkings()
        commit(PARKING.SET_SITE, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      }
    },
    async getAllParkingsGroupedBySite ({commit, dispatch}, clientId) {
      return new Promise((resolve) => {
        parkingService.getAllParkingsGroupedBySite(clientId).then(response => {
          commit(PARKING.SET_ALL_PARKINGS_GROUPED_BY_SITE, response.data)
          resolve()
        }).catch(() => {
          commit(PARKING.SET_ALL_PARKINGS_GROUPED_BY_SITE, [])
        }).finally(
          dispatch('Global/hideLoading', null, {root:true})
        )
      })
    },
    async getParkingDevices ({commit, dispatch}, parkingId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        let response = await parkingService.getParkingDevices(parkingId)
        commit(PARKING.SET_PARKING_DEVICES, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        commit(PARKING.SET_PARKING_DEVICES, [])
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveParkingDevices ({dispatch}, payload) {
      try {
        await parkingService.saveParkingDevices(payload.workPlaceId, payload.devicesIds)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async activateParking ({dispatch}, parking) {
      try {
        await parkingService.activateParking(parking)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch (error) {
        errorhandler.handleError(error);
        throw error
      }
    },
    async deactivateParking ({dispatch}, payload) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await parkingService.deactivateParking(payload.parking, payload.cancelFutureBookings)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch (error) {
        errorhandler.handleError(error);
        throw error
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async getParkingIntegration ({dispatch}, parkingId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        let response = await parkingService.getParkingIntegration(parkingId)
        return response
      }
      catch (error) {
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveIntegration ({dispatch}, payload) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await parkingService.saveIntegration(payload.parkingId, payload.integration)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    }
  }
}
